import ColumnContainer from "../../shared/components/Layout/ColumnContainer"
import RowContainer from "../../shared/components/Layout/RowContainer"
import SkeletonLoader from "../../shared/components/SkeletonLoader"

export const ProfileSlideOverSkeleton: React.FC = () => (
  <div className="px-6">
    <RowContainer>
      <SkeletonLoader height={128} width={200} />
      <ColumnContainer styleOverrides="h-4 w-2/3">
        <SkeletonLoader height={24} />
        <SkeletonLoader lineCount={3} height={16} />
      </ColumnContainer>
    </RowContainer>
    <RowContainer styleOverrides="w-full pt-4">
      <SkeletonLoader
        height={40}
        className="!w-1/2"
        containerClassName="flex-1"
      />
    </RowContainer>
    <ColumnContainer>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => (
        <div key={index} className="pt-2">
          <SkeletonLoader height={32} />
          <SkeletonLoader />
        </div>
      ))}
    </ColumnContainer>
  </div>
)
